<script>
import { mapState } from 'vuex';

export default {
  props: {
    totalSteps: {
      type: [Number],
      default: 3,
    },
  },
  computed: {
    ...mapState('assistantWizard', {
      step: 'step',
    }),
  },
};
</script>

<template>
  <section class="flex w-80 flex-col items-center">
    <section class="flex w-full flex-1 flex-row h-2 py-4">
      <div
        v-for="item in totalSteps"
        :key="item"
        class="flex-1 p-1 rounded-md mr-1 ml-1 bg-slate-100"
        :class="{ 'bg-slate-100': item !== step, 'bg-woot-500': item === step }"
      />
    </section>
    <section>
      <p>
        {{ $t('ASSISTANT_MGMT.WIZARD.PROGRESS_STEP_TXT') }} {{ step }} /
        {{ totalSteps }}
      </p>
    </section>
  </section>
</template>
